import TariffTimeline from "../../../components/TarifSelection/TariffTimeline";
import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import { Tariff } from "src/models/clientsModel";
import { Certificate1, Certificate2 } from "src/assets";
import { Box, CardMedia, Collapse, Stack } from "@mui/material";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { SESSION_KEYS, SITE_TECHNICAL_DATA } from "src/consts/session";

interface TarifSelectionContainerProps {
  tariffsData?: Tariff[];
  showTrustBadges: boolean;
  showSavingsResult: boolean;
  showTariffTimeline: boolean;
  topTextKey?: string;
}

const TarifSelectionContainer = ({
  tariffsData,
  showTrustBadges,
  showSavingsResult,
  showTariffTimeline,
  topTextKey,
}: TarifSelectionContainerProps) => {
  const { t } = useTranslation();

  const [getSiteTechnicalData] = useSessionStorage<SITE_TECHNICAL_DATA>(
    SESSION_KEYS.SITE_TECHNICAL_DATA,
  );

  const isSmartMeterInstalled =
    (getSiteTechnicalData()?.smartMeterInstalled ?? "") === "true";

  return (
    <Stack sx={{ borderRadius: "14px", gap: 5 }}>
      <Stack sx={{ px: 3, mt: !isSmartMeterInstalled ? 5 : 3 }}>
        <Stack direction="row" sx={{ justifyContent: "center" }} />
      </Stack>

      <Stack sx={{ px: 3, pb: 3 }}>
        <Stack alignItems="center" justifyContent="center" />

        <Collapse in={showTariffTimeline}>
          <Stack gap={2}>
            {topTextKey && (
              <Text
                sx={(theme) => ({
                  color: theme.palette.app.primaryFont,
                  fontSize: "20px",
                  fontWeight: "600",
                  lineHeight: "26px",
                  fontFamily: "isonType",
                  letterSpacing: "-0.4px",
                  mb: 4,
                })}
                text={`${t(topTextKey as any)}`}
              />
            )}

            <TariffTimeline
              tariffsData={tariffsData}
              showSavingsResult={showSavingsResult}
            />
          </Stack>

          {showTrustBadges && (
            <Stack
              mt={2}
              gap={5}
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              <Box
                sx={{
                  height: { xs: "153px", sm: "103px" },
                  width: { xs: "153px", sm: "103px" },
                }}
              >
                <CardMedia
                  alt="Zertifikat1"
                  component="img"
                  image={Certificate1}
                  sx={{ objectFit: "contain" }}
                />
              </Box>
              <Box
                sx={{
                  height: { xs: "108px", sm: "73px" },
                  width: { xs: "108px", sm: "73px" },
                }}
              >
                <CardMedia
                  alt="Zertifikat2"
                  component="img"
                  image={Certificate2}
                  sx={{ objectFit: "contain" }}
                />
              </Box>
            </Stack>
          )}
        </Collapse>

        <Stack
          alignItems="center"
          mt={!showTariffTimeline ? 0 : 3}
          justifyContent="center"
        />
      </Stack>
    </Stack>
  );
};

export default TarifSelectionContainer;
